import axios from 'axios';
import sha1 from 'sha1';

export const config = {
        cloudName: 'dsneuxkgk',
        apiKey: '955993865971526',
        apiSecret: 'AhUXMvnOz45haywxs4pfy2JQ6bw',
        preset: 'xzhdvznd',
        tags: ['stoneways'],
        folder: 'stoneways',
        thumbWidth: 200,
        thumbHeight: 200,
        copywrightOverlay: 'stoneways_overlay_sltngp'
};

export const imageURL = `https://res.cloudinary.com/${config.cloudName}/image/upload`

export const thumbParams = `w_${config.thumbWidth},h_${config.thumbHeight}`

export const cloudinaryApi = axios.create({
    baseURL: `https://api.cloudinary.com/v1_1/${config.cloudName}`
});

export const cloudinaryRes = axios.create({
    baseURL: `https://res.cloudinary.com/${config.cloudName}/image`,
    mode: 'no-cors'
});

export function getTimestamp () {
    return (Date.now() / 1000) | 0
}

export function getSignature (stringToSign, timestamp) {
    return sha1(`${stringToSign}&timestamp=${timestamp}${config.apiSecret}`);
}

